import { CourseItemType } from "./types";

export const getAvailableCourses = (courses: CourseItemType[]) =>
  courses.filter(({ courseIsAvailable }) => courseIsAvailable);

export const getCourseById = (courses, id) =>
  courses.find((course) => course?.id === id);
